export default "/_nuxt/445744fb81f987618c950c4abb930c44.svg";